export default "__VITE_ASSET__b8da92b4__"